import moment from 'moment'
import { reverse } from 'ramda'
import { toast } from 'react-hot-toast'

export const DATE_FORMATS = {
  dashed: 'DD-MM-YYYY',
  dashboard: 'DD.MM',
  dashedWithTime: 'DD-MM-YYYY HH:mm',
  exactTime: 'DD-MM-YYYY HH:mm:ss',
  slash: 'DD/MM/YYYY',
  input: 'YYYY-MM-DD',
  inputWithTime: 'YYYY-MM-DDTHH:mm',
  withTimeAndSeconds: 'YYYY-MM-DDTHH:mm:ss',
}

export const formatDate = (date, format) => moment(date).format(format)

export const dateWithTime = (date, lastDate) => {
  if (lastDate) {
    const givenDate = formatDate(date, DATE_FORMATS.input)
    const newDate = moment(lastDate).add(1, 'second')
    const time = newDate.format('HH:mm:ss')
    return `${givenDate}T${time}`
  } else {
    const givenDate = formatDate(date, DATE_FORMATS.input)
    const today = new Date()
    const time = String(today.getHours()).padStart(2, '0') + ":" + String(today.getMinutes()).padStart(2, '0') + ":" + String(today.getSeconds()).padStart(2, '0')
    return `${givenDate}T${time}`
  }
}

export const sortByDates = (array, flip = false) => {
  const sortedArray = array.sort((a, b) => new Date(b.date) - new Date(a.date))
  return flip ? reverse(sortedArray) : sortedArray
}

/**
 * Formats time input: "1630" -> "16:30", "16" -> "16:"
 * When user deletes colon (backspace), don't add it back - allow full deletion
 */
export const formatTimeInput = (value, previousValue = '') => {
  const digits = (value || '').replace(/\D/g, '').slice(0, 4)
  const prevDigits = (previousValue || '').replace(/\D/g, '')
  const prevHadColon = (previousValue || '').includes(':')
  const valueHasColon = (value || '').includes(':')

  if (prevHadColon && !valueHasColon && digits === prevDigits) {
    return digits
  }
  if (digits.length <= 2) return digits.length === 2 ? `${digits}:` : digits
  return `${digits.slice(0, 2)}:${digits.slice(2)}`
}

const copyWithExecCommand = text => {
  const el = document.createElement('textarea')
  el.value = text
  el.setAttribute('readonly', '')
  el.tabIndex = -1
  el.style.position = 'fixed'
  el.style.top = '0'
  el.style.left = '0'
  el.style.width = '2em'
  el.style.height = '2em'
  el.style.opacity = '0'
  el.style.pointerEvents = 'none'
  document.body.appendChild(el)
  el.focus()
  el.select()
  el.setSelectionRange(0, text.length)
  let ok = false
  try {
    ok = document.execCommand('copy')
  } catch {
    ok = false
  }
  document.body.removeChild(el)
  return ok
}

/** Kopiuje tekst; preferuje Clipboard API (działa pewniej z modalami MUI niż sam execCommand). */
export const copyToClipboard = str => () => {
  const text = String(str ?? '')
  const okToast = () => toast.success('Skopiowano')
  const errToast = () => toast.error('Nie udało się skopiować do schowka')

  if (navigator.clipboard?.writeText && window.isSecureContext) {
    navigator.clipboard.writeText(text).then(okToast, () => {
      if (copyWithExecCommand(text)) okToast()
      else errToast()
    })
    return
  }

  if (copyWithExecCommand(text)) okToast()
  else errToast()
}
